import { EChatHintQuestionsActionTypes } from '../../actions/chatHintQuestions';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function hintQuestionsReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EChatHintQuestionsActionTypes.Hide:
      const { chatId } = action.payload || {};

      if (!chatId) {
        return state;
      }

      const openedChat = state.openedChats[chatId];

      if (!openedChat) {
        return state;
      }

      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            hintQuestions: {
              ...openedChat.hintQuestions,
              isVisible: false,
            },
          },
        },
      };

    default:
      return state;
  }
}
